import React, { useState } from 'react';
import { useAuth0TokenContext } from 'contexts/Auth0TokenContext';
import useSignUpManager from '../../useSignUpManager';
import ManualSignUpSection from './ManualSignUpSection';
import SignUpMethodSection from './SignUpMethodSection';

const SignUpForm: React.FC = () => {
    const signUpManager = useSignUpManager();

    const { login } = useAuth0TokenContext();

    const [displayManualSignUp, setDisplayManualSignUp] = useState(false);

    return (
        <form className="DirectSignUp__Form">
            <h1 className="DirectSignUp__Heading">Sign up.</h1>
            {!displayManualSignUp ? (
                <SignUpMethodSection
                    onClickManualSignUp={() => setDisplayManualSignUp(true)}
                    signUpManager={signUpManager}
                />
            ) : (
                <ManualSignUpSection
                    onBack={() => setDisplayManualSignUp(false)}
                    signUpManager={signUpManager}
                />
            )}
            <p className="DirectSignUp__Login">
                Already have an account?
                {' '}
                <button
                    type="button"
                    onClick={login}
                    className="DirectSignUp__Login__Button"
                >
                    <span>Log in</span>
                </button>
            </p>
        </form>
    );
};

export default SignUpForm;
